import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./magic_copy_permission.js";
//#region src/magic_copy_permission_helper.ts
var magic_copy_permission_helper_exports = /* @__PURE__ */ __exportAll({
	SettingsOptionKeys: () => SettingsOptionKeys,
	allowsMenu: () => allowsMenu,
	getDisallowedCrossOrgOptionKeys: () => getDisallowedCrossOrgOptionKeys,
	isCrossOrgOptionKeyAllowed: () => isCrossOrgOptionKeyAllowed,
	name: () => name
});
const SettingsOptionKeys = [
	"commonSettingsV2",
	"featureSettings",
	"flashSettingsV2",
	"fulfillmentSettings",
	"kioskSettingsV2",
	"languageSettings",
	"openHours",
	"paymentSettings",
	"presentationSettings",
	"receiptSettings",
	"recommendationSettingsV2"
];
const neverCrossOrgOptionKeySet = /* @__PURE__ */ new Set(["integrations"]);
const settingsOptionKeySet = new Set(SettingsOptionKeys);
function name(magicCopyPermission) {
	switch (magicCopyPermission) {
		case "configuration-only": return "Configuration Only";
		case "configuration-and-menu": return "Configuration and Menu";
	}
}
function allowsMenu(magicCopyPermission) {
	switch (magicCopyPermission) {
		case "configuration-only": return false;
		case "configuration-and-menu": return true;
	}
}
function isCrossOrgOptionKeyAllowed(magicCopyPermission, optionKey) {
	if (neverCrossOrgOptionKeySet.has(optionKey)) return false;
	return allowsMenu(magicCopyPermission) || settingsOptionKeySet.has(optionKey);
}
function getDisallowedCrossOrgOptionKeys(magicCopyPermission, optionKeys) {
	return optionKeys.filter((optionKey) => {
		return !isCrossOrgOptionKeyAllowed(magicCopyPermission, optionKey);
	});
}
//#endregion
export { SettingsOptionKeys, allowsMenu, getDisallowedCrossOrgOptionKeys, isCrossOrgOptionKeyAllowed, magic_copy_permission_helper_exports, name };

//# sourceMappingURL=magic_copy_permission_helper.js.map